import styled from "styled-components";

export const StyledDrugMobileTocTabsWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
`;
